// import COMPANY_API from '@/api/masterData/company.js';

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'paymentApplyNumber',
    title: '付款申请单编号',
    visible: true,
  },
  {
    field: 'purchaseOrderNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'payeeName',
    title: '供应商 ',
    visible: true,
  },
  {
    field: 'requestAmount',
    title: '申请金额原币',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'paidAmount',
    title: '已付款金额原币',
    visible: true,
  },
  // {
  //   field: 'deductionAmount',
  //   title: '可抵扣金额原币',
  //   visible: true,
  // },
  // {
  //   field: 'realityDeductionAmount',
  //   title: '本次抵扣金额原币',
  //   visible: true,
  //   editRender: { name: 'realityDeductionAmount' },
  // },
];
